// PrivacyPolicy.js

import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
    
       <p className='pp-point'> 1. Introduction <br /></p>

        Introduction These terms and conditions apply to your use of Shawniks (“we”, “our”, “us”). Ensuring the privacy of its members and the confidentiality of the information provided is a matter of serious concern for this site. The primary intent of this Privacy Policy is to inform you of the data we collect and how we manage it in our website or as you engage our services.<br />

        <p className='pp-point'>2. Information We Collect <br /></p> 

        We may collect and process the following information about you:We may collect and process the following information about you:

        Personal Information: This ranges from your name to your residential, physical and mail address, telephone numbers, e-mail addresses and all forms of contacts.
        Loan Information: Information that concerns the kind of loan that you have in mind or have applied for, the loan amount, loan duration, the interest rate charged and any property information.
        Financial Information: Fact based information involving your financial situation description, and history in terms of, income, employment records, credit records, and bank statements.
        Usage Data: Data about the use of our site and cookies such as your IP address, the type of browser you are using, the pages viewed by you. <br />
        <p className='pp-point'>3. Information We Collect When You Use Our Services <br /></p> 

        We may use your information for the following purposes:We may use your information for the following purposes:

        To Process Loan Applications: To evaluate the possibility of issuing you a loan and to complete the loan application process.
        To Communicate with You: To communicate with you regarding your loan application and statistical updates, notifications, and any related information that may concern you on our services.
        To Improve Our Services: For the better understanding of website and services provided through the site and for getting the necessary kind of feedback of the users or visitors.
        To Comply with Legal Obligations: It necessary for compliance as required by and in accordance with laws, regulations and legal proceedings. <br />
        <p className='pp-point'>4. Sharing Your Information <br /></p> 

        We also do not use or disclose your personal information for commercial purposes or for the benefit of any other organisation. However, we may share your information with:However, we may share your information with:

        Lending Partners: Other institutions and lenders we engage in processing your loan application and other loan related services.
        Service Providers: Contractors that Support us in service provision such as payments and credit providers, analysts, and customer care services, among others.
        Legal Authorities: We may share your information if we are mandated by law or if compelled by legal paperwork to so with the government or other legal entities. <br />

        <p className='pp-point'>5. Data Security <br /></p> 

        To guard against loss and against unauthorised or unlawful Processing of your Personal Information, we apply measures commensurate to the risk of occurrence of such an event. But let us mention that the methods of its transfer over the Internet and its storing in electronic media are not completely secure and, thus, we cannot assure you of the full security of the information. <br />

        <p className='pp-point'>6. Your Rights <br /></p> 

        You have the right to:The rights available to you are as follows:

        Access Your Information: Request for a copy of the information which we hold concerning you.
        Correct Your Information: A person also has the right of making corrections if there is some of the information given is inaccurate or incomplete.
        Delete Your Information: Not included in the storage of your personal information or asking for its deletion, to the extent that exceptions, permit it.
        Opt-Out: Have the right to request that we will refrain from sending them to you. <br />

   
    </div>
  );
}
